import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Sample images (replace these with your actual QR code artworks)
import qrCode1 from "../assets/qrcode1.png";
import qrCode2 from "../assets/qrcode2.png";
import qrCode3 from "../assets/qrcode3.png";

const LandingPage = () => {
  return (
    <div className="bg-black text-white font-minimalist min-h-screen flex flex-col">
      {/* Hero Section */}
      <header className="flex flex-col-reverse md:flex-row items-center justify-center h-screen p-6 md:p-12">
        {/* Left: Text Content */}
        <div className="md:w-1/2 lg:w-2/5 md:pr-8 text-center md:text-left">
          <h1 className="text-4xl md:text-6xl font-medium font-futuristic mb-6 tracking-wider leading-tight">
            QR Codes that 
            <span className="text-yellow-400 font-semibold"> WOW</span>
          </h1>
          <p className="text-lg md:text-2xl max-w-xl mb-8 text-gray-300">
            Stand out. <br /> Get scanned. <br /> Build connections <br /> like never before.
          </p>
          {/* Uncomment the button below if needed */}
          {/* <button className="bg-white text-black px-8 py-3 uppercase font-bold tracking-wider hover:opacity-80 transition-all duration-200">
            Get Started
          </button> */}
        </div>

        {/* Right: Image Content */}
        <div className="md:w-1/2 lg:w-1/3 flex justify-center items-center">
          <img
            src={qrCode1}
            alt="Artistic QR Code"
            className="w-1/2 md:w-full max-w-sm h-auto rounded-lg shadow-lg"
          />
        </div>
      </header>



      {/* Carousel Section */}
      <section className="py-16 bg-gray-900">
        <h2 className="text-3xl md:text-4xl font-bold font-futuristic text-center mb-10">
          Featured QR
        </h2>     
        <div className="max-w-5xl mx-auto">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000 }}
            className="h-96 w-full"
          >
            <SwiperSlide className="flex items-center justify-center">
              <img
                src={qrCode1}
                alt="QR Code Art 1"
                className="object-contain h-80 w-auto rounded-lg shadow-lg mx-auto"
              />
            </SwiperSlide>
            <SwiperSlide className="flex items-center justify-center">
              <img
                src={qrCode2}
                alt="QR Code Art 2"
                className="object-contain h-80 w-auto rounded-lg shadow-lg mx-auto"
              />
            </SwiperSlide>
            <SwiperSlide className="flex items-center justify-center">
              <img
                src={qrCode3}
                alt="QR Code Art 3"
                className="object-contain h-80 w-auto rounded-lg shadow-lg mx-auto"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </section>


      {/* Services / Features Section */}
      <section className="py-20 px-6 bg-black">
        <h2 className="text-3xl md:text-4xl font-bold font-futuristic text-center mb-12">
          What We Offer
        </h2>
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <h3 className="text-xl font-semibold font-futuristic mb-4">Custom Designs</h3>
            <p className="text-gray-400">
              Tailored QR codes that blend seamlessly with your brand’s aesthetic,
              ensuring they captivate and engage.
            </p>
          </div>
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <h3 className="text-xl font-semibold font-futuristic mb-4">Premium Quality</h3>
            <p className="text-gray-400">
              High-resolution, detailed designs built to make a lasting impression
              on both digital and print mediums.
            </p>
          </div>
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <h3 className="text-xl font-semibold font-futuristic mb-4">Versatile Formats</h3>
            <p className="text-gray-400">
              QR codes optimized for various use cases, from websites to
              advertisements and even large-scale installations.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-futuristic mb-6">
          Ready to Modernize Your Brand?
        </h2>
        <p className="text-gray-400 mb-8 max-w-3xl mx-auto">
          Contact us today to discuss your project and get a personalized quote. Let’s
          turn your QR codes into captivating works of art!
        </p>
        <button className="bg-white text-black px-8 py-3 uppercase font-bold tracking-wider hover:opacity-80 transition-all duration-200">
          Contact Us
        </button>
      </section>

      {/* Footer */}
      <footer className="bg-black text-gray-500 py-4 text-center">
        <p>
          &copy; {new Date().getFullYear()} Artistic QR Codes. All Rights Reserved.
        </p>
      </footer>
    </div>
  );
};

export default LandingPage;
